import { GraphQLClient } from 'graphql-request'
import { getSdk } from './generated/sdk'
import { getCookie } from '@/lib/csrf'

const rawEndpoint = import.meta.env.VITE_GRAPHQL_HTTP || '/graphql'
// graphql-request requires an absolute URL; resolve relative paths against current origin.
const endpoint = rawEndpoint.startsWith('http')
    ? rawEndpoint
    : new URL(rawEndpoint, window.location.origin).toString()

const client = new GraphQLClient(endpoint, {
    credentials: 'include',
    fetch: (input: RequestInfo | URL, init?: RequestInit) => {
        const csrf = getCookie('csrftoken')
        const headers = new Headers(init?.headers)
        if (csrf && !headers.has('X-CSRFToken')) {
            headers.set('X-CSRFToken', csrf)
        }
        return fetch(input, { ...init, headers })
    }
})

export const sdk = getSdk(client)
export type Sdk = typeof sdk
